module.exports = __webpack_public_path__ + "static/media/14.104.dbb59ff0.webp";